module.exports = __webpack_public_path__ + "VIPH16.png?c141ae78fd8134eb3ef22b27ba818dba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH16.png
// module id = 88
// module chunks = 0